import { reactive } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { downloadAttachment, toUploadRelativePath } from '@/utils/attachmentDownload'

const IMAGE_EXT = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'])
const PDF_EXT = new Set(['pdf'])

export const attachmentPreviewState = reactive({
  visible: false,
  fileUrl: '',
  fileName: ''
})

export function getAttachmentPreviewKind(fileName) {
  const ext = String(fileName || '').split('.').pop()?.toLowerCase() || ''
  if (IMAGE_EXT.has(ext)) return 'image'
  if (PDF_EXT.has(ext)) return 'pdf'
  return 'unsupported'
}

async function parseBlobError(blob) {
  try {
    const text = await blob.text()
    const json = JSON.parse(text)
    return json.message || '预览失败'
  } catch (e) {
    return '预览失败'
  }
}

export async function fetchAttachmentInlineBlob(fileUrl, fileName) {
  const path = toUploadRelativePath(fileUrl)
  if (!path) {
    throw new Error('无法预览该附件')
  }
  const token = localStorage.getItem('token')
  const baseURL = process.env.VUE_APP_API_BASE || ''
  const response = await axios.get(`${baseURL}/api/files/inline`, {
    params: {
      path,
      name: fileName || ''
    },
    responseType: 'blob',
    headers: token ? { Authorization: token } : {},
    timeout: 60000
  })
  const blob = response.data
  const contentType = response.headers['content-type'] || blob?.type || ''
  if (contentType.includes('application/json')) {
    const message = await parseBlobError(blob)
    throw new Error(message)
  }
  return { blob, contentType }
}

export function closeAttachmentPreview() {
  attachmentPreviewState.visible = false
}

export function previewAttachment(fileUrl, fileName) {
  if (!fileUrl) {
    ElMessage.warning('附件地址无效')
    return
  }
  const kind = getAttachmentPreviewKind(fileName)
  if (kind === 'unsupported') {
    ElMessage.info('该格式暂不支持在线预览，将为您下载')
    downloadAttachment(fileUrl, fileName)
    return
  }
  attachmentPreviewState.fileUrl = fileUrl
  attachmentPreviewState.fileName = fileName || '附件'
  attachmentPreviewState.visible = true
}
